import { render } from "./ConfigurationsIndex.vue?vue&type=template&id=e994ce7a"
import script from "./ConfigurationsIndex.vue?vue&type=script&lang=js"
export * from "./ConfigurationsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__